import { useState } from 'react';
import { SuppliersList } from './list';
import { SupplierFormModal } from './SupplierFormModal';
import type { Supplier } from '../../types';
import { useB2BAccess } from '../../hooks/useModuleAccess';

export const SuppliersPage = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState<Supplier | null>(null);
  const { hasAccess: hasB2BAccess } = useB2BAccess();

  const handleCreateClick = () => {
    setSelectedSupplier(null);
    setModalOpen(true);
  };

  const handleSupplierClick = (supplier: Supplier) => {
    setSelectedSupplier(supplier);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedSupplier(null);
  };

  return (
    <>
      <SuppliersList
        onCreateClick={hasB2BAccess ? handleCreateClick : undefined}
        onSupplierClick={handleSupplierClick}
        hasB2BAccess={hasB2BAccess}
      />
      <SupplierFormModal
        open={modalOpen}
        onClose={handleModalClose}
        supplier={selectedSupplier}
      />
    </>
  );
};

export { SuppliersList } from './list';
export { SupplierShow } from './show';
